import ReportEditCategoryPersona from './reportEditCategoryPersona'
export default ReportEditCategoryPersona
